var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"opc-cart__count"},[_c('span',{staticClass:"opc-cart__count__title"},[_vm._v(_vm._s(_vm.planCountDesc))]),_c('share-link')],1)}
var staticRenderFns = []

export { render, staticRenderFns }